export const useStyles = () => {
    return {
        container: {
            padding: 3,
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1.5,
        },
        areas: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
        },
        name: {
            flex: '1 0 200px'
        },
        details: {
            flex: '1 0 120px'
        }
    }
}